import { gql } from "@apollo/client";

export const TEMPLATE_GROUP_FIELDS = gql`
  fragment TemplateGroupFields on TemplateGroup {
    uuid
    name
    sharingType
    createdAt
    updatedAt
    user {
      uuid
      firstName
      lastName
    }
    templates {
      id
      autoTemplateId
      position
      autoTemplate {
        uuid
        name
        templateType
        description
        sharingType
        user {
          uuid
        }
      }
    }
  }
`;
